module.exports = __webpack_public_path__ + "static/media/great-catsby.38953131.md";